export default __webpack_public_path__ + "static/media/googleimage.93099d2e.png";